module.exports = __webpack_public_path__ + "assets/img/166101.22034b81.svg";